import React from 'react';
import styles from './CustomNameField.module.scss';

const CustomNameField = ({ field, form, placeholder, showError, sx, label }) => {
  return (
    <div>
      {showError !== true && form?.errors[`${field?.name}`] && (
        <div className={styles.errorMessage}>{form?.errors[`${field?.name}`]}</div>
      )}
      {label && (
        <div className={styles.label}>
          <label>{label}</label>
        </div>
      )}
      <div
        className={`
          ${styles.inputWrapper} 
          ${form?.errors[`${field?.name}`] ? styles.errorBorder : ''}
        `}
        style={{ ...sx }}
      >
        <input
          {...field}
          className={styles.customInput}
          type='text'
          placeholder={placeholder ?? 'Enter your name'}
        />
      </div>
    </div>
  );
};

export default CustomNameField;
